import React from 'react';
import { CompetitorsResults } from '../../types';
import SectionMessage from './SectionMessage';
import { SectionResult } from '../../../types';

type Props = {
    results: CompetitorsResults;
    relevance: number;
    hideMessage?: boolean;
    hideUrl?: boolean;
    render?: (result: SectionResult) => React.ReactNode;
};

export default function SectionCompetitorResults({ results, relevance, hideMessage, hideUrl, render }: Props) {
    return (
        <>
            {Object.entries(results).map(([competitor, sectionResult]) => (
                <div
                    className={`competitor-report-element-description ${relevance !== 0 ? sectionResult.status : ''}`}
                    key={competitor}
                >
                    <SectionMessage
                        url={competitor}
                        status={sectionResult.status}
                        relevance={relevance}
                        message={sectionResult.message}
                        hideMessage={hideMessage}
                        hideUrl={hideUrl}
                        hasCompetitors={true}
                    />
                    {render && render(sectionResult)}
                </div>
            ))}
        </>
    );
}
